/* eslint-disable no-unused-vars */
import React, { ReactNode } from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { Facet } from './facet';
import { FacetChip } from './FacetChip';
import { FacetMenu } from './FacetMenu';
import { SearchField } from './SearchField';

interface FilterBarProps {
  facets: Facet[];
  search?: {
    value: string;
    onChange: (value: string) => void;
    label: string;
    placeholder?: string;
  };
  hasActiveFilters: boolean;
  onClear: () => void;
  totalCount?: number;
  countLabel?: string;
  countLabelPlural?: string;
  action?: ReactNode;
}

export const FilterBar = ({
  facets,
  search,
  hasActiveFilters,
  onClear,
  totalCount,
  countLabel = 'resultado',
  countLabelPlural = 'resultados',
  action,
}: FilterBarProps) => {
  const activeFacets = facets.filter((facet) => facet.values.length > 0);
  const activeKeys = new Set(activeFacets.map((facet) => facet.key));
  const availableFacets = facets.filter((facet) => !activeKeys.has(facet.key));

  return (
    <Flex w="full" align="center" flexWrap="wrap" gap="8px" mb="16px">
      {activeFacets.map((facet) => (
        <FacetChip key={facet.key} facet={facet} />
      ))}
      <FacetMenu facets={availableFacets} />

      {hasActiveFilters && (
        <>
          {totalCount !== undefined && (
            <Text pl="4px" fontSize="13px" color="content.body">
              {`${totalCount} ${totalCount === 1 ? countLabel : countLabelPlural}`}
            </Text>
          )}
          <Button variant="ghost" size="sm" onClick={onClear}>
            Limpar
          </Button>
        </>
      )}

      {search && (
        <Flex ml="auto">
          <SearchField
            value={search.value}
            onChange={search.onChange}
            label={search.label}
            placeholder={search.placeholder}
          />
        </Flex>
      )}

      {action && <Flex ml={search ? '0' : 'auto'}>{action}</Flex>}
    </Flex>
  );
};
